import type { QuerySettings } from '@customTypes/index';
import { useQuery } from '@tanstack/react-query';

import type { GetClubProfilePhotoListRequest } from '@/shared/api/requests/photo/club-photo-list/request';
import { getClubProfilePhotoList } from '@/shared/api/requests/photo/club-photo-list/request';

export const useClubProfilePhotoListQuery = (
  params: GetClubProfilePhotoListRequest,
  settings?: QuerySettings<typeof getClubProfilePhotoList>
) =>
  useQuery({
    queryKey: ['ClubProfilePhotoList', params.profileId, params.tags],
    queryFn: () =>
      getClubProfilePhotoList({
        params,
        config: settings?.config
      }),
    ...settings?.options
  });
